export const TENANT_HEADER_NAME = 'Mediacoach-TenantId'
export const HASH_OPTIONS = {
  algorithm: 'md5',
  encoding: 'hex',
}

export const MAX_CACHE_AGE = 5 * 60000 //ms
